/**
 * Route table. Pages are stubbed out and wired up in subsequent tasks.
 */
import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const MethodologyPage = lazy(() => import("./pages/MethodologyPage"));
const ExplanationPage = lazy(() => import("./pages/ExplanationPage"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const TickerPage = lazy(() => import("./pages/TickerPage"));
const TickerDetail = lazy(() => import("./pages/TickerDetail"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const PublicDemo = lazy(() => import("./pages/PublicDemo"));
const HeroMocks = lazy(() => import("./pages/HeroMocks"));
const WebGLMockPage = lazy(() => import("./pages/WebGLMockPage"));
const NextGenTickerMock = lazy(() => import("./pages/NextGenTickerMock"));
const PriorityRedesign = lazy(() => import("./pages/PriorityRedesign"));

function Loading() {
  return (
    <main className="min-h-screen bg-bg-app text-text-secondary p-3 font-sans">Loading…</main>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ticker/:symbol" element={<TickerPage />} />
        <Route path="/tickers/:symbol" element={<TickerDetail />} />
        <Route path="/methodology" element={<MethodologyPage />} />
        <Route path="/explanation" element={<ExplanationPage />} />
        <Route path="/how-to-read" element={<ExplanationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/demo" element={<PublicDemo />} />
        <Route path="/mocks/hero-cards" element={<HeroMocks />} />
        <Route path="/mocks/webgl" element={<WebGLMockPage />} />
        <Route path="/mocks/next-gen-ticker" element={<NextGenTickerMock />} />
        <Route path="/mocks/priority-redesign" element={<PriorityRedesign />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
